import TableErrorMessage from "./TableErrorMessage.jsx";

export default TableErrorMessage;



// WEBPACK FOOTER //
// ./src/components/common/errorBoundary/tableErrorMessage/index.js